<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-6">
            <div v-if="$route.query.member_pha">
              <a @click="openPage('/memberPha')" class="link-back"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
            </div>
            <div v-else>
              <a @click="openPage('/memberPhaAssign?last_page='+$route.query.last_page)" class="btn-grey"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <div class="row justify-content-center mt-30">
          <div class="col-sm-10">
            <form @submit.prevent="validateData('plannerEdit')" data-vv-scope="plannerEdit">
              <b-row class="mb-20">
                <b-col sm="3">
                  <label>Personal Trainer</label>
                </b-col>
                <b-col sm="9">
                  <b-form-select @change="filterPtSession" class="border-bottom" name="personal_trainer" v-validate="'required'" v-model="editPlanner.personal_trainer_id">
                    <option :value="null">Please select</option>
                    <option v-for="listItem in itemPt" :key="listItem.id" :value="listItem.id">{{listItem.name}}</option>
                  </b-form-select>
                  <span class="error">{{ errors.first('ptSession.personal_trainer') }}</span>
                </b-col>
              </b-row>
              <div class="text-right">
                <button type="submit" class="btn-primary">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import { ModelSelect } from 'vue-search-select'
import moment from 'moment'

export default {
  name: 'reschedulePha',
  components: {
    ModelSelect
  },
  data: function () {
    return {
      dateConfig: {
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d F Y",
        defaultDate: '2019-05-15',
        minDate: moment().startOf('month').format('YYYY-MM-DD')
      },
      listMember: [],
      optionsMember: [],
      itemPt: [],
      dataActivity: [],
      plannerActivity: [],
      plannerActivity2: [],
      planner_id: '',
      addData: {
        personal_trainer_id: null,
      },
      optionsMember: [
        { value: 0, text: 'Please select' }
      ],
      itemTime: [],
      addPlanner: {
        personal_trainer_id: '',
        member_id: 0,
        pt_planner_activity_id: 2,
        pt_planner_time_id: null,
        date: ''
      },
      editPlanner: {
        personal_trainer_id: null,
      },
    }
  },
  methods: {
    ifPlannerMember (event) {
      if (event === 1 || event === 2 || event === 3 || event === 4 || event === 5 || event === 6) {
        return true
      } else {
        return false
      }
    },
    validateData (scope) {
      this.$validator.validateAll(scope).then((result) => {
        if(result) {
          axios.put('fitness/v1/member_pt_session/' + this.$route.query.id, this.editPlanner).then(response => {
            this.$router.push('/memberPhaAssign')
            this.$toast.success('data saved successfully!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          }).catch(error => {
            // console.log('error', error)
            this.$toast.success('cant saved data!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          })
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    openPage (event) {
      this.$router.push(event)
    },
    previewImage: function(event) {
        // Reference to the DOM input element
        var input = event.target;
        // Ensure that you have a file before attempting to read it
        if (input.files && input.files[0]) {
            // create a new FileReader to read this image and convert to base64 format
            var reader = new FileReader();
            // Define a callback function to run, when FileReader finishes its job
            reader.onload = (e) => {
                // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                // Read image as base64 and set to imageData
                this.imageData = e.target.result;
            }
            // Start the reader job - read file as a data url (base64 format)
            reader.readAsDataURL(input.files[0]);
        }
    },
    fetchData() {
      // turn off autocomplete
      if(document.getElementsByTagName) {
        var inputElements = document.getElementsByTagName("member_id")
        for (var i=0; inputElements[i]; i++) {
          if (inputElements[i].className && (inputElements[i].className.indexOf("disableAutoComplete") != -1)) {
            inputElements[i].setAttribute("autocomplete","off")
          }
        }
      }
      axios.get('crm/v1/pt_planner_time?sorting=id&sorting_type=asc').then(response => {
        // this.itemTime = response.data.data.rows
        var dataTime = [...response.data.data.rows]

        var getLength = dataTime.length
        dataTime.splice(getLength - 1, 1)
        this.itemTime = dataTime
        // console.log('error', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('fitness/v1/personal_training?status=active&sorting=name&sorting_type=asc').then(response => {
        this.itemPt = response.data.data.rows
        // console.log('test', response)
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('crm/v1/pt_planner_activity?sorting=id&sorting_type=asc').then(response => {
        this.dataActivity = response.data.data.rows
        var data1 = [...response.data.data.rows]
        var data2 = [...response.data.data.rows]

        var getLength = data1.length
        data1.splice(getLength - 5, 5)
        this.plannerActivity = data1

        // console.log('test data 2', this.plannerActivity2)
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('fitness/v1/member/data_entry').then(response => {
        this.listMember = response.data.data.rows
        for (var i = 0; i < this.listMember.length; i++) {
          let memberBranchId
          if(!this.listMember[i].branch_id) {
            memberBranchId = '(FT-' + this.listMember[i].id + ') ' + this.listMember[i].first_name + ' ' + this.listMember[i].last_name
          } else {
            memberBranchId = '(' + this.listMember[i].branch.codename + '-' + this.listMember[i].id + ') ' + this.listMember[i].first_name + ' ' + this.listMember[i].last_name
          }
          // var dataComplete = Object.assign({}, {value: null, text: 'Please select' }, {value: this.listMember[i].id, text: this.listMember[i].first_name + ' ' + this.listMember[i].last_name})
          var dataComplete = Object.assign({}, {value: null, text: 'Please select' }, {value: this.listMember[i].id, text: memberBranchId})
          this.optionsMember.push(dataComplete)
        }
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('crm/v1/pt_planner/' + this.$route.query.id).then(response => {
        var getPhaDate = response.data.data.date
        // console.log(getPhaDate)
        this.dateConfig.minDate = moment(getPhaDate).startOf('month').format('YYYY-MM-DD')
        this.addPlanner.date = moment(getPhaDate).startOf('month').format('YYYY-MM-DD')
        // console.log('error', response.data.data)
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    // this.addPlanner.pt_planner_time_id = this.$route.query.planner_time
    // this.addPlanner.date = this.$route.query.date
    this.addPlanner.personal_trainer_id = Auth.Session.get().paradigm_id
    this.addPlanner.member_id = this.$route.query.member_id
    this.fetchData()
  }
}
</script>

<style>
</style>
